// antd component
import React from "react";

import { Popconfirm, Button } from "antd";
// icons
import { DeleteOutlined, MinusCircleOutlined } from "@ant-design/icons";
import CustomIcons from "components/CustomIcons";

import { i18n } from "engine/Contexts/AppProviders";
// Open new row with form
const openNewRow = (rows, setRows, form) => {
  // reset data in the form
  form.resetFields();
  // set initial data for new row
  const initial = {
    key: "initial",
    firstname: "initial",
    lastname: "initial",
  };
  const isRows = rows && rows.length > 0;
  const hasInitRow = isRows && rows.some(row => row.key === "initial");
  // add new row from the start
  if (!hasInitRow) {
    isRows ? setRows([initial, ...rows]) : setRows([initial]);
  }
};

const removeNewRow = (rows, setRows) => {
  const newRows = rows.filter(row => row.key !== "initial" && row);
  setRows(newRows);
};

const confirmSaveRowData = (rows, setRows, confirmHandle) => (
  <>
    <Popconfirm
      placement="top"
      title={i18n.t("notifications.confirmSaveDataAsk")}
      okText={i18n.t("common.yes")}
      cancelText={i18n.t("common.no")}
      onCancel={() => removeNewRow(rows, setRows)}
      onConfirm={() => confirmHandle()}
    >
      <Button className="save-action-btn">{i18n.t("common.add")}</Button>
    </Popconfirm>
    <MinusCircleOutlined
      onClick={() => removeNewRow(rows, setRows)}
      className="delete-action"
    />
  </>
);

const confirmRemoveRowData = (record, confirmHandle) => (
  <Popconfirm
    placement="top"
    title={i18n.t("common.removalRequest")}
    okText={i18n.t("common.yes")}
    cancelText={i18n.t("common.no")}
    onConfirm={() => confirmHandle(record)}
    overlayClassName="popconfirm-window"
  >
    <DeleteOutlined className="delete-action" />
  </Popconfirm>
);

const starRowDataActions = ({
  record,
  rows,
  setRows,
  confirmHandle,
  checked,
  msg,
}) => {
  return (
    <>
      <Popconfirm
        placement="left"
        title={!!msg ? msg : i18n.t("notifications.defineCourseLeader")}
        okText={i18n.t("common.yes")}
        cancelText={i18n.t("common.no")}
        onCancel={() => removeNewRow(rows, setRows)}
        onConfirm={() => confirmHandle(record)}
      >
        <CustomIcons
          className="star-action"
          type={`${checked ? "star" : "star-empty"}`}
        />
      </Popconfirm>
    </>
  );
};

const getUniqueArrayObj = (arrayObj, prop) => {
  const result = [];
  const map = new Map();
  for (const item of arrayObj) {
    if (!map.has(item[prop])) {
      map.set(item[prop], true); // set any value to Map
      result.push({ ...item });
    }
  }
  return result;
};

export {
  openNewRow,
  removeNewRow,
  confirmSaveRowData,
  confirmRemoveRowData,
  starRowDataActions,
  getUniqueArrayObj,
};
